import {Dispatch, ThunkAction} from '../../../../../../../types/actions';
import {boardImportBoardCSVLearnMoreClickedSegmentEvent} from '../../../../../main/navigationPanel/effects/segmentEvents';

export const onClickCsvLearnMore = (): ThunkAction => {
    const action = (dispatch: Dispatch) => {
        dispatch(boardImportBoardCSVLearnMoreClickedSegmentEvent());
    };
    return action;
};
